/* tslint:disable */
import * as Types from '../../../../../../graphql-api/baskets-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type OrdersQueryVariables = Types.Exact<{
  query: Types.FilterQuery;
}>;


export type OrdersQuery = { orders: { total?: { requestedQuantity?: number | null, confirmedQuantity?: number | null, totalPriceNet?: { currency?: string | null, value?: number | null } | null } | null, orders: Array<{ rootId?: string | null, rootTitle?: string | null, salesOrderNumber: string, clientReferenceNumber?: string | null, orderReferenceNumber?: string | null, basketId?: string | null, orderType?: string | null, orderDate?: any | null, updatedDate?: any | null, requestedDate?: any | null, address?: string | null, requestedQuantity?: number | null, confirmedQuantity?: number | null, trackingNumbers?: Array<string | null> | null, status?: string | null, thumbnails?: Array<string> | null, totalPriceNet?: { currency?: string | null, value?: number | null } | null, priceNetConfirmed?: { currency?: string | null, value?: number | null } | null, unitPriceNet?: { currency?: string | null, value?: number | null } | null, priceRrp?: { currency?: string | null, value?: number | null } | null, unitPriceRrp?: { currency?: string | null, value?: number | null } | null, account?: { id?: string | null, externalId?: string | null, name?: string | null } | null }>, pagination: { size?: number | null, afterKey?: string | null } } };

export const OrdersDocument = gql`
    query Orders($query: FilterQuery!) {
  orders(query: $query) {
    total {
      totalPriceNet {
        currency
        value
      }
      requestedQuantity
      confirmedQuantity
    }
    orders {
      rootId
      rootTitle
      salesOrderNumber
      clientReferenceNumber
      orderReferenceNumber
      basketId
      orderType
      orderDate
      updatedDate
      requestedDate
      address
      requestedQuantity
      confirmedQuantity
      totalPriceNet {
        currency
        value
      }
      priceNetConfirmed {
        currency
        value
      }
      unitPriceNet {
        currency
        value
      }
      priceRrp {
        currency
        value
      }
      unitPriceRrp {
        currency
        value
      }
      trackingNumbers
      status
      account {
        id
        externalId
        name
      }
      thumbnails
    }
    pagination {
      size
      afterKey
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrdersGQL extends Apollo.Query<OrdersQuery, OrdersQueryVariables> {
    document = OrdersDocument;
    client = 'baskets';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }